// import React, { useState, useEffect } from "react";
// import {
//     Box, Typography, Button, Snackbar, Alert, CircularProgress,
//     Tabs, Tab, Checkbox, Dialog, DialogTitle,
//     DialogContent, DialogActions, IconButton, MenuItem, Select,
//     TextField, useTheme, useMediaQuery
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import axios from "axios";
// import { useAuth } from "../context/AuthContext";
// import SearchIcon from "@mui/icons-material/Search";
// import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
// import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
// import TuneIcon from "@mui/icons-material/Tune";
// import CloseIcon from "@mui/icons-material/Close";
// import ClearIcon from "@mui/icons-material/Clear";

// // ── Enterprise ERP Design Tokens ──────────────────────────────────────────────
// const NAVY     = "#0D2137";          // Page header background
// const STEEL    = "#1B4FBB";          // Primary action colour
// const STEEL_LT = "#EBF2FF";          // Light tint (hover, subtle)
// const PAGE_BG  = "#F4F6F9";          // Screen / page background
// const CARD     = "#FFFFFF";          // Card / panel background
// const BORDER   = "#E2E8F0";          // Standard border
// const TH_BG    = "#F7F9FC";          // Table column-header background
// const T1       = "#1A202C";          // Primary text
// const T2       = "#4A5568";          // Secondary text
// const T3       = "#718096";          // Muted / label text
// const POS      = "#276749";          // Positive amount (paid / credit)
// const NEG      = "#9B2C2C";          // Negative amount (outstanding / overdue)
// const WHITE    = "#FFFFFF";

// // ── Button / input sx ────────────────────────────────────────────────────────
// const btnHeaderGhost = {
//     color: "rgba(255,255,255,0.88)", border: "1px solid rgba(255,255,255,0.25)",
//     background: "transparent", borderRadius: "4px", fontSize: 12, fontWeight: 500,
//     textTransform: "none", px: 1.75, height: 30, whiteSpace: "nowrap",
//     "&:hover": { background: "rgba(255,255,255,0.1)", borderColor: "rgba(255,255,255,0.5)" },
//     "&:disabled": { color: "rgba(255,255,255,0.3)", borderColor: "rgba(255,255,255,0.1)" },
// };
// const btnHeaderSolid = {
//     color: NAVY, background: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 700,
//     textTransform: "none", px: 1.75, height: 30, whiteSpace: "nowrap",
//     "&:hover": { background: "#E8EDF5" },
// };
// const btnPrimary = {
//     background: STEEL, color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
//     textTransform: "none", px: 2, height: 32, whiteSpace: "nowrap",
//     "&:hover": { background: "#1640A0" },
//     "&:disabled": { background: BORDER, color: T3 },
// };
// const btnGhost = {
//     color: T2, border: `1px solid ${BORDER}`, background: "transparent",
//     borderRadius: "4px", fontSize: 12, fontWeight: 500, textTransform: "none",
//     px: 1.5, height: 30, whiteSpace: "nowrap",
//     "&:hover": { background: PAGE_BG, color: T1 },
// };
// const inputSx = {
//     "& .MuiOutlinedInput-root": {
//         borderRadius: "4px", background: WHITE, fontSize: 13,
//         "& fieldset": { borderColor: BORDER },
//         "&:hover fieldset": { borderColor: STEEL },
//         "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
//     },
// };
// const dgSx = {
//     border: "none",
//     "& .MuiDataGrid-columnHeaders": { background: TH_BG, borderBottom: `1px solid ${BORDER}` },
//     "& .MuiDataGrid-columnHeaderTitle": { fontSize: 11, fontWeight: 700, color: T2, letterSpacing: ".5px", textTransform: "uppercase" },
//     "& .MuiDataGrid-cell": { borderBottom: `1px solid ${BORDER}`, outline: "none !important", display: "flex", alignItems: "center" },
//     "& .MuiDataGrid-row:hover": { background: STEEL_LT },
//     "& .MuiDataGrid-row:nth-of-type(even)": { background: "#FAFBFD" },
//     "& .MuiDataGrid-footerContainer": { borderTop: `1px solid ${BORDER}`, background: TH_BG },
//     "& .MuiTablePagination-root": { fontSize: 12, color: T2 },
// };

// // ── Helper functions ──────────────────────────────────────────────────────────
// const getFinancialYearDates = () => {
//     const today = new Date();
//     const yr = today.getFullYear();
//     const fyStart = new Date(yr, 3, 2);
//     if (today < fyStart) fyStart.setFullYear(yr - 1);
//     const fyEnd = new Date(fyStart.getFullYear() + 1, 2, 32);
//     return { fromDate: fyStart.toISOString().split("T")[0], toDate: fyEnd.toISOString().split("T")[0] };
// };
// const fmt = (n) => Number(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
// const fmtDate = (d) => {
//     if (!d || d === "—") return "—";
//     const p = String(d).split("-");
//     if (p.length !== 3) return d;
//     return `${p[2]}/${p[1]}/${p[0]}`;
// };
// const calculateDaysDifference = (billDate) => {
//     if (!billDate) return 0;
//     let dt;
//     if (String(billDate).includes("/")) {
//         const [dd, mm, yyyy] = billDate.split("/");
//         dt = new Date(`${yyyy}-${mm}-${dd}`);
//     } else { dt = new Date(billDate); }
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     dt.setHours(0, 0, 0, 0);
//     const diff = Math.ceil((today.getTime() - dt.getTime()) / 86400000);
//     return diff > 0 ? diff : 0;
// };

// // ── Report Configuration Dialog ───────────────────────────────────────────────
// function SmartFilterDialog({ open, onClose, allClients, tempFromDate, setTempFromDate, tempToDate, setTempToDate, tempClientSearchText, setTempClientSearchText, tempSelectedClients, setTempSelectedClients, filteredTempClients, handleTempClientCheckbox, loading, onGetData, reportType, setReportType }) {
//     useEffect(() => {
//         if (open) { setTempClientSearchText(""); setTempSelectedClients([]); }
//     }, [reportType]);

//     return (
//         <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
//             PaperProps={{ sx: { borderRadius: "6px", border: `1px solid ${BORDER}`, boxShadow: "0 12px 40px rgba(0,0,0,0.18)", overflow: "hidden" } }}>

//             {/* Dialog Header — dark navy */}
//             <DialogTitle sx={{ p: 0 }}>
//                 <Box sx={{ background: NAVY, px: 2.5, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Box>
//                         <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1 }}>Report Configuration</Typography>
//                         <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: "3px" }}>Set parameters to generate the sale bills report</Typography>
//                     </Box>
//                     <IconButton onClick={onClose} size="small"
//                         sx={{ color: "rgba(255,255,255,0.6)", "&:hover": { background: "rgba(255,255,255,0.1)" } }}>
//                         <CloseIcon sx={{ fontSize: 18 }} />
//                     </IconButton>
//                 </Box>
//             </DialogTitle>

//             <DialogContent sx={{ px: 2.5, py: 2.5, background: WHITE }}>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>

//                     {/* Report Type */}
//                     <Box>
//                         <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", textTransform: "uppercase", letterSpacing: ".5px" }}>Report Type</Typography>
//                         <Select fullWidth size="small" value={reportType} onChange={(e) => setReportType(e.target.value)}
//                             sx={{ borderRadius: "4px", fontSize: 13, "& fieldset": { borderColor: BORDER }, "&:hover fieldset": { borderColor: STEEL }, "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 } }}>
//                             <MenuItem value="sale-outstanding">Sale Outstanding Bills</MenuItem>
//                             <MenuItem value="sale-overdue">Sale Overdue Bills</MenuItem>
//                         </Select>
//                     </Box>

//                     {/* Date Range */}
//                     <Box>
//                         <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", textTransform: "uppercase", letterSpacing: ".5px" }}>Date Range</Typography>
//                         <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
//                             <Box>
//                                 <Typography sx={{ fontSize: 11, color: T2, mb: "4px", fontWeight: 500 }}>From</Typography>
//                                 <TextField type="date" fullWidth size="small" value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} sx={inputSx} />
//                             </Box>
//                             <Box>
//                                 <Typography sx={{ fontSize: 11, color: T2, mb: "4px", fontWeight: 500 }}>To</Typography>
//                                 <TextField type="date" fullWidth size="small" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} sx={inputSx} />
//                             </Box>
//                         </Box>
//                     </Box>

//                     {/* Client Selection */}
//                     <Box>
//                         <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", textTransform: "uppercase", letterSpacing: ".5px" }}>
//                             Clients &nbsp;
//                             <Typography component="span" sx={{ fontSize: 11, color: T2, fontWeight: 400, textTransform: "none", letterSpacing: 0 }}>
//                                 ({tempSelectedClients.length} of {allClients.length} selected)
//                             </Typography>
//                         </Typography>
//                         <TextField fullWidth size="small" placeholder="Search clients…" value={tempClientSearchText}
//                             onChange={(e) => setTempClientSearchText(e.target.value)} sx={{ ...inputSx, mb: 1 }}
//                             InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: T3, fontSize: 16 }} /> }} />
//                         <Box sx={{ border: `1px solid ${BORDER}`, borderRadius: "4px", overflow: "hidden", maxHeight: 220, overflowY: "auto" }}>
//                             {/* Select All header */}
//                             <Box sx={{ display: "flex", alignItems: "center", px: 1.5, py: "7px", background: TH_BG, borderBottom: `1px solid ${BORDER}`, position: "sticky", top: 0, zIndex: 1 }}>
//                                 <Checkbox size="small"
//                                     checked={tempSelectedClients.length === filteredTempClients.length && filteredTempClients.length > 0}
//                                     indeterminate={tempSelectedClients.length > 0 && tempSelectedClients.length < filteredTempClients.length}
//                                     onChange={() => {
//                                         if (tempSelectedClients.length === filteredTempClients.length) setTempSelectedClients([]);
//                                         else setTempSelectedClients([...tempSelectedClients, ...filteredTempClients.filter(c => !tempSelectedClients.some(s => s.id === c.id))]);
//                                     }}
//                                     sx={{ color: T3, "&.Mui-checked": { color: STEEL }, "&.MuiCheckbox-indeterminate": { color: STEEL }, p: "3px" }} />
//                                 <Typography sx={{ fontSize: 12, fontWeight: 600, color: T2 }}>Select All ({filteredTempClients.length})</Typography>
//                             </Box>
//                             {filteredTempClients.length === 0 ? (
//                                 <Box sx={{ py: 3, textAlign: "center" }}>
//                                     <Typography sx={{ fontSize: 13, color: T3 }}>No clients found</Typography>
//                                 </Box>
//                             ) : filteredTempClients.map((client) => {
//                                 const isSelected = tempSelectedClients.some(c => c.id === client.id);
//                                 return (
//                                     <Box key={client.id} onClick={() => handleTempClientCheckbox(client)}
//                                         sx={{ display: "flex", alignItems: "center", px: 1.5, py: "6px", cursor: "pointer", borderBottom: `1px solid ${BORDER}`, background: isSelected ? STEEL_LT : WHITE, "&:hover": { background: STEEL_LT } }}>
//                                         <Checkbox size="small" checked={isSelected} onChange={() => handleTempClientCheckbox(client)} onClick={(e) => e.stopPropagation()}
//                                             sx={{ color: BORDER, "&.Mui-checked": { color: STEEL }, p: "3px", mr: 0.5 }} />
//                                         <Typography sx={{ fontSize: 13, color: T1, fontWeight: isSelected ? 600 : 400 }}>{client.FirmName}</Typography>
//                                     </Box>
//                                 );
//                             })}
//                         </Box>
//                     </Box>
//                 </Box>
//             </DialogContent>

//             <DialogActions sx={{ px: 2.5, py: 2, gap: 1, borderTop: `1px solid ${BORDER}`, background: TH_BG }}>
//                 <Button onClick={onClose} fullWidth sx={{ ...btnGhost, height: 34 }}>Cancel</Button>
//                 <Button onClick={onGetData} fullWidth disabled={loading || tempSelectedClients.length === 0}
//                     startIcon={loading ? <CircularProgress size={13} sx={{ color: WHITE }} /> : <SearchIcon sx={{ fontSize: 15 }} />}
//                     sx={{ ...btnPrimary, height: 34 }}>
//                     Generate Report
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// }

// // ── Main Component ────────────────────────────────────────────────────────────
// export default function OSandODSaleReport({ connectionString, pdfString }) {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//     const { user, selectedCompany } = useAuth();

//     const [viewMode, setViewMode] = useState("filter");
//     const [filterOpen, setFilterOpen] = useState(false);
//     const [allClients, setAllClients] = useState([]);
//     const [tempClientSearchText, setTempClientSearchText] = useState("");
//     const [filteredTempClients, setFilteredTempClients] = useState([]);
//     const [tempSelectedClients, setTempSelectedClients] = useState([]);
//     const [appliedFilters, setAppliedFilters] = useState(null);
//     const [reportType, setReportType] = useState("sale-outstanding");
//     const [selectedClients, setSelectedClients] = useState([]);
//     const [ledgerDataMap, setLedgerDataMap] = useState({});
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//     const [activeTab, setActiveTab] = useState(0);
//     const [dateFilters, setDateFilters] = useState({});
//     const getTodayDate = () => new Date().toISOString().split("T")[0];
//     const [tempFromDate, setTempFromDate] = useState(getTodayDate());
//     const [tempToDate, setTempToDate] = useState(getTodayDate());
//     const [pdfLoading, setPdfLoading] = useState(false);
//     const companyId = selectedCompany?.CompId;

//     const getApiEndpoint = () => {
//         switch (reportType) {
//             case "sale-outstanding": return `${connectionString}/api/getSaleOutStandingBillData`;
//             case "sale-overdue": return `${connectionString}/api/getSaleOverDueBillData`;
//             default: return `${connectionString}/api/getSaleOutStandingBillData`;
//         }
//     };
//     const getPdfFormat = () => ({ "sale-outstanding": "format_9", "sale-overdue": "format_10" }[reportType] || "format_9");
//     const getPdfDocId = () => ({ "sale-outstanding": "sale-outstanding-bill-report", "sale-overdue": "sale-overdue-bill-report" }[reportType] || "sale-outstanding-bill-report");
//     const getReportTypeLabel = () => ({ "sale-outstanding": "Sale Outstanding Bills", "sale-overdue": "Sale Overdue Bills" }[reportType] || "Outstanding Bills");
//     const getReportTypeShort = () => (reportType.includes("outstanding") ? "outstanding" : "overdue");

//     const fetchAllClients = async () => {
//         try {
//             const { fromDate: fyFromDate, toDate: fyToDate } = getFinancialYearDates();
//             const res = await axios.get(getApiEndpoint(), { params: { compId: companyId, fromDate: fyFromDate, toDate: fyToDate, reportType: "with_parties" } });
//             const sorted = (res.data?.parties || []).sort((a, b) => a.FirmName.localeCompare(b.FirmName));
//             setAllClients(sorted);
//             setFilteredTempClients(sorted);
//         } catch (err) {
//             setAllClients([]); setFilteredTempClients([]);
//             setSnackbar({ open: true, message: err.response?.data?.error || "Failed to fetch clients", severity: "error" });
//         }
//     };

//     const groupClientsByCity = (clients) => {
//         const grouped = {};
//         clients.forEach(c => { const city = c.City || c.city || "OTHER"; if (!grouped[city]) grouped[city] = []; grouped[city].push(c); });
//         return Object.keys(grouped).sort().reduce((acc, city) => { acc[city] = grouped[city]; return acc; }, {});
//     };

//     const handleExportPDF = async () => {
//         try {
//             setPdfLoading(true);
//             const format = getPdfFormat(); const docId = getPdfDocId();
//             const printDate = new Date().toISOString().split("T")[0];
//             const toDateRaw = appliedFilters?.toDate || getFinancialYearDates().toDate;
//             const clientsByCity = groupClientsByCity(selectedClients);
//             const allEntries = [];
//             Object.entries(clientsByCity).forEach(([city, cityClients]) => {
//                 cityClients.forEach(client => {
//                     const cd = ledgerDataMap[client.id];
//                     if (cd?.details?.length > 0) {
//                         cd.details.forEach(r => allEntries.push({ city, clientKey: String(client.id), firmName: client.FirmName || "", contactPerson: client.ContactPerson || "", mobileNo: client.MobileNo || "", billDate: r.docDate || "", billNumber: r.docNo || "", pmtTermsDays: r.PmtTermsDays !== undefined ? r.PmtTermsDays : 0, billAmt: Number(r.BillAmt || 0), paidAmt: Number(r.PaidAmt || 0), osAmt: Number(r.OSAmt || 0), days: r.Days || 0, dueDate: r.dueDate || "" }));
//                     }
//                 });
//             });
//             const pdfData = { fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate, toDate: fmtDate(toDateRaw), printDate, entries: allEntries };
//             const companyHeader = selectedCompany ? { CompId: selectedCompany.CompId, CompanyName: selectedCompany.CompanyName || "", Address: selectedCompany.Address || "", MobileNo: selectedCompany.MobileNo || "", EmailId: selectedCompany.EmailId || "", GSTNo: selectedCompany.GSTNo || "" } : {};
//             const pdfResp = await axios.post(`${pdfString}/api/stock-pdf/${format}`, { docId, data: pdfData, company: companyHeader, companyIconFormat: "jpg" }, { responseType: "blob" });
//             const w = window.open(URL.createObjectURL(new Blob([pdfResp.data], { type: "application/pdf" })), "_blank");
//             if (w) w.focus();
//         } catch (err) {
//             setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
//         } finally { setPdfLoading(false); }
//     };

//     const handleTempClientSearch = (searchText) => {
//         setTempClientSearchText(searchText);
//         if (!searchText.trim()) setFilteredTempClients(allClients);
//         else setFilteredTempClients(allClients.filter(c =>
//             (c.FirmName && c.FirmName.toLowerCase().includes(searchText.toLowerCase())) ||
//             (c.ClientCode && c.ClientCode.toLowerCase().includes(searchText.toLowerCase())) ||
//             (c.ContactPerson && c.ContactPerson.toLowerCase().includes(searchText.toLowerCase()))
//         ));
//     };

//     const handleTempClientCheckbox = (client) => {
//         setTempSelectedClients(prev => prev.some(c => c.id === client.id) ? prev.filter(c => c.id !== client.id) : [...prev, client]);
//     };

//     const processOutstandingBillData = (item, index, daysOld) => ({ id: item.id || `bill-${index}`, docDate: item.billDate, docNo: item.billNumber, bookName: item.bookName, PmtTermsDays: item.paymentTerm, BillAmt: Number(item.billAmt || 0), PaidAmt: Number(item.paidAmt || 0), OSAmt: Number(item.billAmt || 0) - Number(item.paidAmt || 0), Days: daysOld, remark: item.remark, refNo: item.refNo, balance: Number(item.billAmt || 0) - Number(item.paidAmt || 0), balanceType: "Dr" });
//     const processOverdueBillData = (item, index, daysOld) => ({ id: item.id || `bill-${index}`, docDate: item.billDate, docNo: item.billNumber, dueDate: item.dueDate, bookName: item.bookName, PmtTermsDays: item.paymentTerm, BillAmt: Number(item.billAmt || 0), PaidAmt: Number(item.paidAmt || 0), OSAmt: Number(item.billAmt || 0) - Number(item.paidAmt || 0), Days: daysOld, remark: item.remark, refNo: item.refNo, balance: Number(item.billAmt || 0) - Number(item.paidAmt || 0), balanceType: "Dr" });

//     const fetchPartyDetail = async (partyId, fromDateVal, toDateVal) => {
//         try {
//             const res = await axios.get(getApiEndpoint(), { params: { compId: companyId, partyId, fromDate: fromDateVal, toDate: toDateVal } });
//             if (res.data) {
//                 const short = getReportTypeShort();
//                 const detailsData = (res.data.details || []).map((item, index) => {
//                     const daysOld = short === "overdue" ? calculateDaysDifference(item.dueDate) : calculateDaysDifference(item.billDate);
//                     return short === "outstanding" ? processOutstandingBillData(item, index, daysOld) : processOverdueBillData(item, index, daysOld);
//                 });
//                 setLedgerDataMap(prev => ({ ...prev, [partyId]: { openingBalance: { absValue: 0, type: "Dr" }, closingBalance: { closingBal: 0, type: "Dr" }, details: detailsData, summary: { totalTransactions: res.data.totalRecords || detailsData.length, totalDebit: detailsData.reduce((s, r) => s + Number(r.BillAmt || 0), 0), totalCredit: detailsData.reduce((s, r) => s + Number(r.PaidAmt || 0), 0) } } }));
//                 setDateFilters(prev => ({ ...prev, [partyId]: prev[partyId] || { fromDate: fromDateVal, toDate: toDateVal } }));
//             }
//         } catch (err) {
//             setSnackbar({ open: true, message: err.response?.data?.error || "Failed to fetch party details", severity: "error" });
//         }
//     };

//     const handleViewSelectedLedgers = async () => {
//         if (tempSelectedClients.length === 0) { setSnackbar({ open: true, message: "Please select at least one client", severity: "warning" }); return; }
//         try {
//             setLoading(true);
//             await Promise.all(tempSelectedClients.map(c => fetchPartyDetail(c.id, tempFromDate, tempToDate)));
//             setSelectedClients(tempSelectedClients);
//             setAppliedFilters({ fromDate: tempFromDate, toDate: tempToDate, clientCount: tempSelectedClients.length, reportType });
//             setViewMode("detail"); setActiveTab(0); setFilterOpen(false);
//         } catch (err) {
//             setSnackbar({ open: true, message: "Failed to fetch ledger data", severity: "error" });
//         } finally { setLoading(false); }
//     };

//     const handleClear = () => { setViewMode("filter"); setLedgerDataMap({}); setDateFilters({}); setActiveTab(0); setSelectedClients([]); setAppliedFilters(null); setTempClientSearchText(""); setFilteredTempClients(allClients); setTempSelectedClients([]); };

//     const handleOpenFilter = () => {
//         const { fromDate: fyFrom, toDate: fyTo } = getFinancialYearDates();
//         setTempFromDate(fyFrom); setTempToDate(fyTo);
//         setTempClientSearchText(""); setFilteredTempClients(allClients); setTempSelectedClients([]);
//         setFilterOpen(true);
//     };

//     useEffect(() => { if (companyId) fetchAllClients(); }, [companyId, reportType]);
//     useEffect(() => { setFilteredTempClients(allClients); }, [allClients]);

//     const getColumns = () => {
//         const isOverdue = getReportTypeShort() === "overdue";
//         return [
//             { field: "docDate", headerName: "Bill Date", flex: 0.9, minWidth: 100, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: T1 }}>{fmtDate(value)}</Typography> },
//             ...(isOverdue ? [{ field: "dueDate", headerName: "Due Date", flex: 0.9, minWidth: 100, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: T1 }}>{fmtDate(value)}</Typography> }] : []),
//             { field: "docNo", headerName: "Bill No", flex: 0.85, minWidth: 100, renderCell: ({ value }) => <Typography sx={{ fontSize: 12, fontWeight: 700, color: STEEL, fontFamily: "monospace" }}>{value}</Typography> },
//             { field: "PmtTermsDays", headerName: "Pmt. Terms (Days)", flex: 1.1, minWidth: 130, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: T2 }}>{value === "OPBAL" ? "—" : value}</Typography> },
//             { field: "BillAmt", headerName: "Bill Amt (₹)", flex: 1, minWidth: 120, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 600, color: T1 }}>{fmt(Number(value))}</Typography> },
//             { field: "PaidAmt", headerName: "Paid Amt (₹)", flex: 1, minWidth: 120, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 600, color: POS }}>{fmt(Number(value))}</Typography> },
//             { field: "OSAmt", headerName: "O.S. Amt (₹)", flex: 1, minWidth: 120, align: "right", headerAlign: "right", renderCell: ({ row }) => <Typography sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 700, color: NEG }}>{fmt(Number(row.OSAmt || 0))}</Typography> },
//             { field: "Days", headerName: "Days Old", flex: 0.7, minWidth: 90, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: T2, fontFamily: "monospace" }}>{value === "—" ? "—" : value}</Typography> },
//         ];
//     };
//     const columns = getColumns();

//     const dialogProps = {
//         open: filterOpen, onClose: () => setFilterOpen(false),
//         allClients, tempFromDate, setTempFromDate, tempToDate, setTempToDate,
//         tempClientSearchText, setTempClientSearchText: handleTempClientSearch,
//         tempSelectedClients, setTempSelectedClients, filteredTempClients,
//         handleTempClientCheckbox, loading, onGetData: handleViewSelectedLedgers,
//         reportType, setReportType,
//     };

//     const snackbarEl = (
//         <Snackbar open={snackbar.open} autoHideDuration={3500} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
//             <Alert severity={snackbar.severity} onClose={() => setSnackbar(s => ({ ...s, open: false }))} sx={{ borderRadius: "4px", fontWeight: 600, fontSize: 13 }}>{snackbar.message}</Alert>
//         </Snackbar>
//     );

//     // ── Enterprise Page Header ────────────────────────────────────────────────
//     const pageHeader = (title, subtitle, actions) => (
//         <Box sx={{ background: NAVY, display: "flex", alignItems: "center", px: { xs: 2, sm: 3 }, minHeight: 56, flexShrink: 0, gap: 2 }}>
//             <Box sx={{ width: 30, height: 30, borderRadius: "4px", background: "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//                 <ReceiptLongOutlinedIcon sx={{ fontSize: 17, color: WHITE }} />
//             </Box>
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//                 <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1.2 }}>{title}</Typography>
//                 {subtitle && <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: "2px" }}>{subtitle}</Typography>}
//             </Box>
//             <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexShrink: 0 }}>{actions}</Box>
//         </Box>
//     );

//     // ── KPI Cards ─────────────────────────────────────────────────────────────
//     const kpiCards = (items) => (
//         <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, 1fr)" }, gap: { xs: 1, sm: 1.5 }, px: { xs: 1.5, sm: 2 }, pt: { xs: 1.5, sm: 2 }, pb: 0 }}>
//             {items.map((item, i) => (
//                 <Box key={i} sx={{ background: CARD, border: `1px solid ${item.accent ? "#FEB2B2" : BORDER}`, borderRadius: "6px", p: "12px 14px", borderLeft: `3px solid ${item.accent ? NEG : STEEL}` }}>
//                     <Typography sx={{ fontSize: 10, fontWeight: 700, color: T3, textTransform: "uppercase", letterSpacing: ".7px", mb: "8px" }}>{item.label}</Typography>
//                     <Typography sx={{ fontSize: 18, fontWeight: 700, color: item.accent ? NEG : T1, fontVariantNumeric: "tabular-nums", lineHeight: 1 }}>{item.value}</Typography>
//                 </Box>
//             ))}
//         </Box>
//     );

//     // ── Filter view ───────────────────────────────────────────────────────────
//     if (viewMode === "filter") {
//         return (
//             <Box sx={{ background: PAGE_BG, display: "flex", flexDirection: "column", minHeight: "100%" }}>
//                 {pageHeader(
//                     "Sale Bills Report",
//                     "Reports › Outstanding & Overdue Analysis",
//                     <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 14 }} />} sx={btnHeaderSolid}>
//                         Configure Report
//                     </Button>
//                 )}
//                 <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 3 }}>
//                     <Box sx={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: "6px", p: { xs: 3, sm: 4 }, maxWidth: 400, width: "100%", textAlign: "center" }}>
//                         <ReceiptLongOutlinedIcon sx={{ fontSize: 36, color: T3, mb: 1.5 }} />
//                         <Typography sx={{ fontSize: 14, fontWeight: 700, color: T1, mb: 0.75 }}>No Report Selected</Typography>
//                         <Typography sx={{ fontSize: 13, color: T3, lineHeight: 1.65, mb: 2.5 }}>
//                             Configure report parameters to view outstanding or overdue sale bills.
//                         </Typography>
//                         <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 14 }} />} sx={btnPrimary}>
//                             Configure & Run Report
//                         </Button>
//                     </Box>
//                 </Box>
//                 <OSandODSaleFilterDialog {...dialogProps} />
//                 {snackbarEl}
//             </Box>
//         );
//     }

//     // ── Detail view ───────────────────────────────────────────────────────────
//     const activeClient = selectedClients[activeTab];
//     const activeData = activeClient ? ledgerDataMap[activeClient.id] : null;
//     const activeRows = activeData?.details || [];
//     const totalBills = activeData?.summary?.totalTransactions || activeRows.length;
//     const totalBillAmt = activeData?.summary?.totalDebit || 0;
//     const totalPaidAmt = activeData?.summary?.totalCredit || 0;
//     const totalOS = activeRows.reduce((s, r) => s + Number(r.OSAmt || 0), 0);

//     return (
//         <Box sx={{ background: PAGE_BG, display: "flex", flexDirection: "column", minHeight: "100%" }}>

//             {/* Dark Navy Page Header */}
//             {pageHeader(
//                 getReportTypeLabel(),
//                 `Reports › ${appliedFilters ? `${selectedClients.length} client${selectedClients.length !== 1 ? "s" : ""} · ${fmtDate(appliedFilters.fromDate)} – ${fmtDate(appliedFilters.toDate)}` : "Outstanding & Overdue Analysis"}`,
//                 <>
//                     {selectedClients.length > 0 && (
//                         <Button onClick={handleExportPDF} disabled={pdfLoading}
//                             startIcon={pdfLoading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 14 }} />}
//                             sx={btnHeaderGhost}>
//                             {isMobile ? "PDF" : "Export PDF"}
//                         </Button>
//                     )}
//                     <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 14 }} />} sx={btnHeaderSolid}>
//                         {isMobile ? "Filter" : "Modify Filter"}
//                     </Button>
//                 </>
//             )}

//             {/* KPI Summary Cards */}
//             {activeRows.length > 0 && kpiCards([
//                 { label: "Total Bills", value: String(totalBills), accent: false },
//                 { label: "Bill Amount", value: `₹ ${fmt(totalBillAmt)}`, accent: false },
//                 { label: "Paid Amount", value: `₹ ${fmt(totalPaidAmt)}`, accent: false },
//                 { label: "Outstanding", value: `₹ ${fmt(totalOS)}`, accent: true },
//             ])}

//             {/* Main Content Panel */}
//             <Box sx={{ p: { xs: 1.5, sm: 2 }, flex: 1 }}>
//                 <Box sx={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: "6px", overflow: "hidden" }}>

//                     {/* Active Filter Status Bar */}
//                     {appliedFilters && (
//                         <Box sx={{ px: { xs: 1.5, sm: 2 }, py: "9px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, background: TH_BG, borderBottom: `1px solid ${BORDER}` }}>
//                             <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", alignItems: "center" }}>
//                                 <Typography sx={{ fontSize: 10, color: T3, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".5px", mr: 0.5 }}>Active Filters:</Typography>
//                                 {[getReportTypeLabel(), `${fmtDate(appliedFilters.fromDate)} – ${fmtDate(appliedFilters.toDate)}`, `${appliedFilters.clientCount} client${appliedFilters.clientCount > 1 ? "s" : ""}`].map(tag => (
//                                     <Box key={tag} sx={{ px: 1, py: "2px", background: NAVY, borderRadius: "3px" }}>
//                                         <Typography sx={{ fontSize: 11, fontWeight: 500, color: WHITE }}>{tag}</Typography>
//                                     </Box>
//                                 ))}
//                             </Box>
//                             <Button onClick={handleClear} size="small" startIcon={<ClearIcon sx={{ fontSize: 11 }} />} sx={btnGhost}>
//                                 Clear
//                             </Button>
//                         </Box>
//                     )}

//                     {/* Client Tabs */}
//                     {selectedClients.length > 0 && (
//                         <Box sx={{ borderBottom: `1px solid ${BORDER}` }}>
//                             <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} variant="scrollable" scrollButtons="auto"
//                                 sx={{ px: 1, minHeight: 40,
//                                     "& .MuiTabs-indicator": { background: STEEL, height: 2, borderRadius: 0 },
//                                     "& .MuiTab-root": { textTransform: "none", fontWeight: 500, fontSize: 13, color: T3, minHeight: 40, px: 2, py: 0, "&.Mui-selected": { color: STEEL, fontWeight: 600 } }
//                                 }}>
//                                 {selectedClients.map((client, idx) => {
//                                     const count = ledgerDataMap[client.id]?.details?.length || 0;
//                                     return (
//                                         <Tab key={client.id} id={`tab-${idx}`}
//                                             label={
//                                                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
//                                                     <span>{client.FirmName}</span>
//                                                     <Box sx={{ minWidth: 18, height: 16, px: "4px", background: count > 0 ? NAVY : T3, borderRadius: "2px", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                                                         <Typography sx={{ fontSize: 10, fontWeight: 700, color: WHITE, lineHeight: 1 }}>{count}</Typography>
//                                                     </Box>
//                                                 </Box>
//                                             }
//                                         />
//                                     );
//                                 })}
//                             </Tabs>
//                         </Box>
//                     )}

//                     {/* Grid Content */}
//                     {selectedClients.map((client, idx) => {
//                         if (idx !== activeTab) return null;
//                         const clientData = ledgerDataMap[client.id];
//                         const displayRows = clientData?.details || [];
//                         const billAmt = clientData?.summary?.totalDebit || 0;
//                         const paidAmt = clientData?.summary?.totalCredit || 0;
//                         const osAmt = displayRows.reduce((s, r) => s + Number(r.OSAmt || 0), 0);
//                         return (
//                             <Box key={client.id}>
//                                 {loading ? (
//                                     <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 6, gap: 1.5 }}>
//                                         <CircularProgress size={20} sx={{ color: STEEL }} />
//                                         <Typography sx={{ color: T2, fontSize: 13 }}>Loading bills…</Typography>
//                                     </Box>
//                                 ) : displayRows.length > 0 ? (
//                                     <>
//                                         <DataGrid
//                                             rows={displayRows} columns={columns}
//                                             autoHeight rowHeight={38}
//                                             getRowId={(row) => row.id}
//                                             disableRowSelectionOnClick
//                                             pageSizeOptions={[25, 50, 100]}
//                                             initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
//                                             sx={dgSx}
//                                         />
//                                         {/* Totals Footer */}
//                                         <Box sx={{ background: TH_BG, borderTop: `1px solid ${BORDER}`, px: { xs: 1.5, sm: 2.5 }, py: 1.25, display: "flex", alignItems: "center", gap: { xs: 2, sm: 4 }, flexWrap: "wrap" }}>
//                                             <Typography sx={{ fontSize: 11, fontWeight: 700, color: T2, textTransform: "uppercase", letterSpacing: ".4px" }}>
//                                                 {displayRows.length} Bill{displayRows.length !== 1 ? "s" : ""}
//                                             </Typography>
//                                             <Box sx={{ display: "flex", gap: { xs: 2, sm: 3 }, ml: "auto", flexWrap: "wrap" }}>
//                                                 {[
//                                                     { label: "Bill Amt", val: fmt(billAmt), color: T1 },
//                                                     { label: "Paid Amt", val: fmt(paidAmt), color: POS },
//                                                     { label: "Outstanding", val: fmt(osAmt), color: NEG },
//                                                 ].map(({ label, val, color }) => (
//                                                     <Box key={label} sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
//                                                         <Typography sx={{ fontSize: 11, color: T3 }}>{label}:</Typography>
//                                                         <Typography sx={{ fontSize: 13, fontWeight: 700, color, fontVariantNumeric: "tabular-nums" }}>₹ {val}</Typography>
//                                                     </Box>
//                                                 ))}
//                                             </Box>
//                                         </Box>
//                                     </>
//                                 ) : (
//                                     <Box sx={{ py: 5, textAlign: "center" }}>
//                                         <ReceiptLongOutlinedIcon sx={{ fontSize: 30, color: BORDER, mb: 1 }} />
//                                         <Typography sx={{ fontSize: 13, color: T3 }}>No bills found for {client.FirmName}</Typography>
//                                     </Box>
//                                 )}
//                             </Box>
//                         );
//                     })}
//                 </Box>
//             </Box>

//             <OSandODSaleFilterDialog {...dialogProps} />
//             {snackbarEl}
//         </Box>
//     );
// }





import { colors as themeColors } from '../utils/theme';
import React, { useState, useEffect } from "react";
import {
    Box, Typography, Button, Snackbar, Alert, CircularProgress,
    Tabs, Tab, useTheme, useMediaQuery
} from "@mui/material";
import OSandODSaleFilterDialog from "./OSandODSaleFilterDialog";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import ClearIcon from "@mui/icons-material/Clear";

// ── Enterprise ERP Design Tokens ──────────────────────────────────────────────
const NAVY = "#0D2137";          // Page header background
const STEEL = "#1B4FBB";          // Primary action colour
const STEEL_LT = "#EBF2FF";          // Light tint (hover, subtle)
const PAGE_BG = "#F4F6F9";          // Screen / page background
const CARD = themeColors.neutral.surface;          // Card / panel background
const BORDER = themeColors.neutral.line;          // Standard border
const TH_BG = "#F7F9FC";          // Table column-header background
const T1 = themeColors.neutral.ink;          // Primary text
const T2 = "#4A5568";          // Secondary text
const T3 = "#718096";          // Muted / label text
const POS = "#276749";          // Positive amount (paid / credit)
const NEG = "#9B2C2C";          // Negative amount (outstanding / overdue)
const WHITE = themeColors.neutral.surface;

// ── Button / input sx ────────────────────────────────────────────────────────
const btnHeaderGhost = {
    color: "rgba(255,255,255,0.88)", border: "1px solid rgba(255,255,255,0.25)",
    background: "transparent", borderRadius: "4px", fontSize: 12, fontWeight: 500,
    textTransform: "none", px: 1.75, height: 30, whiteSpace: "nowrap",
    "&:hover": { background: "rgba(255,255,255,0.1)", borderColor: "rgba(255,255,255,0.5)" },
    "&:disabled": { color: "rgba(255,255,255,0.3)", borderColor: "rgba(255,255,255,0.1)" },
};
const btnHeaderSolid = {
    color: NAVY, background: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 700,
    textTransform: "none", px: 1.75, height: 30, whiteSpace: "nowrap",
    "&:hover": { background: "#E8EDF5" },
};
const btnPrimary = {
    background: STEEL, color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
    textTransform: "none", px: 2, height: 32, whiteSpace: "nowrap",
    "&:hover": { background: themeColors.primary.darker },
    "&:disabled": { background: BORDER, color: T3 },
};
const btnGhost = {
    color: T2, border: `1px solid ${BORDER}`, background: "transparent",
    borderRadius: "4px", fontSize: 12, fontWeight: 500, textTransform: "none",
    px: 1.5, height: 30, whiteSpace: "nowrap",
    "&:hover": { background: PAGE_BG, color: T1 },
};
const inputSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "4px", background: WHITE, fontSize: 13,
        "& fieldset": { borderColor: BORDER },
        "&:hover fieldset": { borderColor: STEEL },
        "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
    },
};
const dgSx = {
    border: "none",
    "& .MuiDataGrid-columnHeaders": { background: TH_BG, borderBottom: `1px solid ${BORDER}` },
    "& .MuiDataGrid-columnHeaderTitle": { fontSize: 11, fontWeight: 700, color: T2, letterSpacing: ".5px", textTransform: "uppercase" },
    "& .MuiDataGrid-cell": { borderBottom: `1px solid ${BORDER}`, outline: "none !important", display: "flex", alignItems: "center" },
    "& .MuiDataGrid-row:hover": { background: STEEL_LT },
    "& .MuiDataGrid-row:nth-of-type(even)": { background: "#FAFBFD" },
    "& .MuiDataGrid-footerContainer": { borderTop: `1px solid ${BORDER}`, background: TH_BG },
    "& .MuiTablePagination-root": { fontSize: 12, color: T2 },
};

// ── Helper functions ──────────────────────────────────────────────────────────
const getFinancialYearDates = () => {
    const today = new Date();
    const yr = today.getFullYear();
    const fyStart = new Date(yr, 3, 2);
    if (today < fyStart) fyStart.setFullYear(yr - 1);
    const fyEnd = new Date(fyStart.getFullYear() + 1, 2, 32);
    return { fromDate: fyStart.toISOString().split("T")[0], toDate: fyEnd.toISOString().split("T")[0] };
};
const fmt = (n) => Number(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtDate = (d) => {
    if (!d || d === "—") return "—";
    const p = String(d).split("-");
    if (p.length !== 3) return d;
    return `${p[2]}/${p[1]}/${p[0]}`;
};
const calculateDaysDifference = (billDate) => {
    if (!billDate) return 0;
    let dt;
    if (String(billDate).includes("/")) {
        const [dd, mm, yyyy] = billDate.split("/");
        dt = new Date(`${yyyy}-${mm}-${dd}`);
    } else { dt = new Date(billDate); }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    dt.setHours(0, 0, 0, 0);
    const diff = Math.ceil((today.getTime() - dt.getTime()) / 86400000);
    return diff > 0 ? diff : 0;
};

// ── Main Component ────────────────────────────────────────────────────────────
export default function OSandODSaleReport({ connectionString, pdfString, initialReportType, openFilterTrigger }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { user, selectedCompany } = useAuth();

    const [viewMode, setViewMode] = useState("filter");
    const [filterOpen, setFilterOpen] = useState(false);
    const [allClients, setAllClients] = useState([]);
    const [tempClientSearchText, setTempClientSearchText] = useState("");
    const [filteredTempClients, setFilteredTempClients] = useState([]);
    const [tempSelectedClients, setTempSelectedClients] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const [reportType, setReportType] = useState("sale-outstanding");
    const [selectedClients, setSelectedClients] = useState([]);
    const [ledgerDataMap, setLedgerDataMap] = useState({});
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [activeTab, setActiveTab] = useState(0);
    const [dateFilters, setDateFilters] = useState({});
    const getTodayDate = () => new Date().toISOString().split("T")[0];
    const [tempFromDate, setTempFromDate] = useState(getTodayDate());
    const [tempToDate, setTempToDate] = useState(getTodayDate());
    const [tempAsOnDate, setTempAsOnDate] = useState(true);
    const [pdfLoading, setPdfLoading] = useState(false);
    const companyId = selectedCompany?.CompId;

    useEffect(() => {
        if (initialReportType) {
            setReportType(initialReportType);
        }
    }, [initialReportType]);

    useEffect(() => {
        if (openFilterTrigger > 0 && companyId) {
            fetchAllClients().then(() => {
                handleOpenFilter();
            });
        }
    }, [openFilterTrigger, companyId]);

    const getApiEndpoint = () => {
        switch (reportType) {
            case "sale-outstanding": return `${connectionString}/api/getSaleOutStandingBillData`;
            case "sale-overdue": return `${connectionString}/api/getSaleOverDueBillData`;
            default: return `${connectionString}/api/getSaleOutStandingBillData`;
        }
    };
    const getPdfFormat = () => ({ "sale-outstanding": "format_9", "sale-overdue": "format_10" }[reportType] || "format_9");
    const getPdfDocId = () => ({ "sale-outstanding": "sale-outstanding-bill-report", "sale-overdue": "sale-overdue-bill-report" }[reportType] || "sale-outstanding-bill-report");
    const getReportTypeLabel = () => ({ "sale-outstanding": "Sale Outstanding Bills", "sale-overdue": "Sale Overdue Bills" }[reportType] || "Outstanding Bills");
    const getReportTypeShort = () => (reportType.includes("outstanding") ? "outstanding" : "overdue");

    const fetchAllClients = async () => {
        try {
            const { fromDate: fyFromDate, toDate: fyToDate } = getFinancialYearDates();
            const res = await axios.get(getApiEndpoint(), { params: { compId: companyId, fromDate: fyFromDate, toDate: fyToDate, reportType: "with_parties" } });
            const sorted = (res.data?.parties || []).sort((a, b) => a.FirmName.localeCompare(b.FirmName));
            setAllClients(sorted);
            setFilteredTempClients(sorted);
        } catch (err) {
            setAllClients([]); setFilteredTempClients([]);
            setSnackbar({ open: true, message: err.response?.data?.error || "Failed to fetch clients", severity: "error" });
        }
    };

    const groupClientsByCity = (clients) => {
        const grouped = {};
        clients.forEach(c => { const city = c.City || c.city || "OTHER"; if (!grouped[city]) grouped[city] = []; grouped[city].push(c); });
        return Object.keys(grouped).sort().reduce((acc, city) => { acc[city] = grouped[city]; return acc; }, {});
    };

    const handleExportPDF = async () => {
        try {
            setPdfLoading(true);
            const format = getPdfFormat(); const docId = getPdfDocId();
            const printDate = new Date().toISOString().split("T")[0];
            const toDateRaw = appliedFilters?.toDate || getFinancialYearDates().toDate;
            const clientsByCity = groupClientsByCity(selectedClients);
            const allEntries = [];
            Object.entries(clientsByCity).forEach(([city, cityClients]) => {
                cityClients.forEach(client => {
                    const cd = ledgerDataMap[client.id];
                    if (cd?.details?.length > 0) {
                        cd.details.forEach(r => allEntries.push({ city, clientKey: String(client.id), firmName: client.FirmName || "", contactPerson: client.ContactPerson || "", mobileNo: client.MobileNo || "", billDate: r.docDate || "", billNumber: r.docNo || "", pmtTermsDays: r.PmtTermsDays !== undefined ? r.PmtTermsDays : 0, billAmt: Number(r.BillAmt || 0), paidAmt: Number(r.PaidAmt || 0), osAmt: Number(r.OSAmt || 0), days: r.Days || 0, dueDate: r.dueDate || "" }));
                    }
                });
            });
            const pdfData = { fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate, toDate: fmtDate(toDateRaw), printDate, entries: allEntries };
            const companyHeader = selectedCompany ? { CompId: selectedCompany.CompId, CompanyName: selectedCompany.CompanyName || "", Address: selectedCompany.Address || "", MobileNo: selectedCompany.MobileNo || "", EmailId: selectedCompany.EmailId || "", GSTNo: selectedCompany.GSTNo || "" } : {};
            const pdfResp = await axios.post(`${pdfString}/api/stock-pdf/${format}`, { docId, data: pdfData, company: companyHeader, companyIconFormat: "jpg" }, { responseType: "blob" });
            const w = window.open(URL.createObjectURL(new Blob([pdfResp.data], { type: "application/pdf" })), "_blank");
            if (w) w.focus();
        } catch (err) {
            setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
        } finally { setPdfLoading(false); }
    };

    const handleTempClientSearch = (searchText) => {
        setTempClientSearchText(searchText);
        if (!searchText.trim()) setFilteredTempClients(allClients);
        else setFilteredTempClients(allClients.filter(c =>
            (c.FirmName && c.FirmName.toLowerCase().includes(searchText.toLowerCase())) ||
            (c.ClientCode && c.ClientCode.toLowerCase().includes(searchText.toLowerCase())) ||
            (c.ContactPerson && c.ContactPerson.toLowerCase().includes(searchText.toLowerCase()))
        ));
    };

    const handleTempClientCheckbox = (client) => {
        setTempSelectedClients(prev => prev.some(c => c.id === client.id) ? prev.filter(c => c.id !== client.id) : [...prev, client]);
    };

    const processOutstandingBillData = (item, index, daysOld) => ({ id: item.id || `bill-${index}`, docDate: item.billDate, docNo: item.billNumber, bookName: item.bookName, PmtTermsDays: item.paymentTerm, BillAmt: Number(item.billAmt || 0), PaidAmt: Number(item.paidAmt || 0), OSAmt: Number(item.billAmt || 0) - Number(item.paidAmt || 0), Days: daysOld, remark: item.remark, refNo: item.refNo, balance: Number(item.billAmt || 0) - Number(item.paidAmt || 0), balanceType: "Dr" });
    const processOverdueBillData = (item, index, daysOld) => ({ id: item.id || `bill-${index}`, docDate: item.billDate, docNo: item.billNumber, dueDate: item.dueDate, bookName: item.bookName, PmtTermsDays: item.paymentTerm, BillAmt: Number(item.billAmt || 0), PaidAmt: Number(item.paidAmt || 0), OSAmt: Number(item.billAmt || 0) - Number(item.paidAmt || 0), Days: daysOld, remark: item.remark, refNo: item.refNo, balance: Number(item.billAmt || 0) - Number(item.paidAmt || 0), balanceType: "Dr" });

    const fetchPartyDetail = async (partyId, fromDateVal, toDateVal, asOnDate) => {
        try {
            // When "As On Date" is checked, filter using only toDate (fromDate omitted)
            const params = asOnDate
                ? { compId: companyId, partyId, toDate: toDateVal }
                : { compId: companyId, partyId, fromDate: fromDateVal, toDate: toDateVal };
            const res = await axios.get(getApiEndpoint(), { params });
            if (res.data) {
                const short = getReportTypeShort();
                const detailsData = (res.data.details || []).map((item, index) => {
                    const daysOld = short === "overdue" ? calculateDaysDifference(item.dueDate) : calculateDaysDifference(item.billDate);
                    return short === "outstanding" ? processOutstandingBillData(item, index, daysOld) : processOverdueBillData(item, index, daysOld);
                });
                setLedgerDataMap(prev => ({ ...prev, [partyId]: { openingBalance: { absValue: 0, type: "Dr" }, closingBalance: { closingBal: 0, type: "Dr" }, details: detailsData, summary: { totalTransactions: res.data.totalRecords || detailsData.length, totalDebit: detailsData.reduce((s, r) => s + Number(r.BillAmt || 0), 0), totalCredit: detailsData.reduce((s, r) => s + Number(r.PaidAmt || 0), 0) } } }));
                setDateFilters(prev => ({ ...prev, [partyId]: prev[partyId] || { fromDate: fromDateVal, toDate: toDateVal } }));
            }
        } catch (err) {
            setSnackbar({ open: true, message: err.response?.data?.error || "Failed to fetch party details", severity: "error" });
        }
    };

    const handleViewSelectedLedgers = async () => {
        if (tempSelectedClients.length === 0) { setSnackbar({ open: true, message: "Please select at least one client", severity: "warning" }); return; }
        try {
            setLoading(true);
            await Promise.all(tempSelectedClients.map(c => fetchPartyDetail(c.id, tempFromDate, tempToDate, tempAsOnDate)));
            setSelectedClients(tempSelectedClients);
            setAppliedFilters({ fromDate: tempAsOnDate ? null : tempFromDate, toDate: tempToDate, asOnDate: tempAsOnDate, clientCount: tempSelectedClients.length, reportType });
            setViewMode("detail"); setActiveTab(0); setFilterOpen(false);
        } catch (err) {
            setSnackbar({ open: true, message: "Failed to fetch ledger data", severity: "error" });
        } finally { setLoading(false); }
    };

    const handleClear = () => { setViewMode("filter"); setLedgerDataMap({}); setDateFilters({}); setActiveTab(0); setSelectedClients([]); setAppliedFilters(null); setTempClientSearchText(""); setFilteredTempClients(allClients); setTempSelectedClients([]); };

    const handleOpenFilter = () => {
        const { fromDate: fyFrom, toDate: fyTo } = getFinancialYearDates();
        setTempFromDate(fyFrom); setTempToDate(fyTo); setTempAsOnDate(true);
        setTempClientSearchText(""); setFilteredTempClients(allClients); setTempSelectedClients([]);
        setFilterOpen(true);
    };

    useEffect(() => { if (companyId) fetchAllClients(); }, [companyId, reportType]);
    useEffect(() => { setFilteredTempClients(allClients); }, [allClients]);

    const getColumns = () => {
        const isOverdue = getReportTypeShort() === "overdue";
        return [
            { field: "docDate", headerName: "Bill Date", flex: 0.9, minWidth: 100, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: T1 }}>{fmtDate(value)}</Typography> },
            ...(isOverdue ? [{ field: "dueDate", headerName: "Due Date", flex: 0.9, minWidth: 100, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: T1 }}>{fmtDate(value)}</Typography> }] : []),
            { field: "docNo", headerName: "Bill No", flex: 0.85, minWidth: 100, renderCell: ({ value }) => <Typography sx={{ fontSize: 12, fontWeight: 700, color: STEEL, fontFamily: "monospace" }}>{value}</Typography> },
            { field: "PmtTermsDays", headerName: "Pmt. Terms (Days)", flex: 1.1, minWidth: 130, renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: T2 }}>{value === "OPBAL" ? "—" : value}</Typography> },
            { field: "BillAmt", headerName: "Bill Amt (₹)", flex: 1, minWidth: 120, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 600, color: T1 }}>{fmt(Number(value))}</Typography> },
            { field: "PaidAmt", headerName: "Paid Amt (₹)", flex: 1, minWidth: 120, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 600, color: POS }}>{fmt(Number(value))}</Typography> },
            { field: "OSAmt", headerName: "O.S. Amt (₹)", flex: 1, minWidth: 120, align: "right", headerAlign: "right", renderCell: ({ row }) => <Typography sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 700, color: NEG }}>{fmt(Number(row.OSAmt || 0))}</Typography> },
            { field: "Days", headerName: "Days Old", flex: 0.7, minWidth: 90, align: "right", headerAlign: "right", renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: T2, fontFamily: "monospace" }}>{value === "—" ? "—" : value}</Typography> },
        ];
    };
    const columns = getColumns();

    const dialogProps = {
        open: filterOpen, onClose: () => setFilterOpen(false),
        allClients, tempFromDate, setTempFromDate, tempToDate, setTempToDate,
        tempAsOnDate, setTempAsOnDate,
        tempClientSearchText, setTempClientSearchText: handleTempClientSearch,
        tempSelectedClients, setTempSelectedClients, filteredTempClients,
        handleTempClientCheckbox, loading, onGetData: handleViewSelectedLedgers,
        reportType, setReportType,
    };

    const snackbarEl = (
        <Snackbar open={snackbar.open} autoHideDuration={3500} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
            <Alert severity={snackbar.severity} onClose={() => setSnackbar(s => ({ ...s, open: false }))} sx={{ borderRadius: "4px", fontWeight: 600, fontSize: 13 }}>{snackbar.message}</Alert>
        </Snackbar>
    );

    // ── Enterprise Page Header ────────────────────────────────────────────────
    const pageHeader = (title, subtitle, actions) => (
        <Box sx={{ background: NAVY, display: "flex", alignItems: "center", px: { xs: 2, sm: 3 }, minHeight: 56, flexShrink: 0, gap: 2 }}>
            <Box sx={{ width: 30, height: 30, borderRadius: "4px", background: "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <ReceiptLongOutlinedIcon sx={{ fontSize: 17, color: WHITE }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1.2 }}>{title}</Typography>
                {subtitle && <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: "2px" }}>{subtitle}</Typography>}
            </Box>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexShrink: 0 }}>{actions}</Box>
        </Box>
    );

    // ── KPI Cards ─────────────────────────────────────────────────────────────
    const kpiCards = (items) => (
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, 1fr)" }, gap: { xs: 1, sm: 1.5 }, px: { xs: 1.5, sm: 2 }, pt: { xs: 1.5, sm: 2 }, pb: 0 }}>
            {items.map((item, i) => (
                <Box key={i} sx={{ background: CARD, border: `1px solid ${item.accent ? "#FEB2B2" : BORDER}`, borderRadius: "6px", p: "12px 14px", borderLeft: `3px solid ${item.accent ? NEG : STEEL}` }}>
                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: T3, textTransform: "uppercase", letterSpacing: ".7px", mb: "8px" }}>{item.label}</Typography>
                    <Typography sx={{ fontSize: 18, fontWeight: 700, color: item.accent ? NEG : T1, fontVariantNumeric: "tabular-nums", lineHeight: 1 }}>{item.value}</Typography>
                </Box>
            ))}
        </Box>
    );

    // ── Filter view ───────────────────────────────────────────────────────────
    if (viewMode === "filter") {
        return (
            <Box sx={{ background: PAGE_BG, display: "flex", flexDirection: "column", minHeight: "100%" }}>
                {pageHeader(
                    "Sale Bills Report",
                    "Reports › Outstanding & Overdue Analysis",
                    <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 14 }} />} sx={btnHeaderSolid}>
                        Configure Report
                    </Button>
                )}
                <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 3 }}>
                    <Box sx={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: "6px", p: { xs: 3, sm: 4 }, maxWidth: 400, width: "100%", textAlign: "center" }}>
                        <ReceiptLongOutlinedIcon sx={{ fontSize: 36, color: T3, mb: 1.5 }} />
                        <Typography sx={{ fontSize: 14, fontWeight: 700, color: T1, mb: 0.75 }}>No Report Selected</Typography>
                        <Typography sx={{ fontSize: 13, color: T3, lineHeight: 1.65, mb: 2.5 }}>
                            Configure report parameters to view outstanding or overdue sale bills.
                        </Typography>
                        <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 14 }} />} sx={btnPrimary}>
                            Configure & Run Report
                        </Button>
                    </Box>
                </Box>
                <OSandODSaleFilterDialog {...dialogProps} />
                {snackbarEl}
            </Box>
        );
    }

    // ── Detail view ───────────────────────────────────────────────────────────
    const activeClient = selectedClients[activeTab];
    const activeData = activeClient ? ledgerDataMap[activeClient.id] : null;
    const activeRows = activeData?.details || [];
    const totalBills = activeData?.summary?.totalTransactions || activeRows.length;
    const totalBillAmt = activeData?.summary?.totalDebit || 0;
    const totalPaidAmt = activeData?.summary?.totalCredit || 0;
    const totalOS = activeRows.reduce((s, r) => s + Number(r.OSAmt || 0), 0);

    const filterDateLabel = appliedFilters
        ? (appliedFilters.asOnDate ? `As On ${fmtDate(appliedFilters.toDate)}` : `${fmtDate(appliedFilters.fromDate)} – ${fmtDate(appliedFilters.toDate)}`)
        : "";

    return (
        <Box sx={{ background: PAGE_BG, display: "flex", flexDirection: "column", minHeight: "100%" }}>

            {/* Dark Navy Page Header */}
            {pageHeader(
                getReportTypeLabel(),
                `Reports › ${appliedFilters ? `${selectedClients.length} client${selectedClients.length !== 1 ? "s" : ""} · ${filterDateLabel}` : "Outstanding & Overdue Analysis"}`,
                <>
                    {selectedClients.length > 0 && (
                        <Button onClick={handleExportPDF} disabled={pdfLoading}
                            startIcon={pdfLoading ? <CircularProgress size={12} sx={{ color: WHITE }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 14 }} />}
                            sx={btnHeaderGhost}>
                            {isMobile ? "PDF" : "Export PDF"}
                        </Button>
                    )}
                    <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 14 }} />} sx={btnHeaderSolid}>
                        {isMobile ? "Filter" : "Modify Filter"}
                    </Button>
                </>
            )}

            {/* KPI Summary Cards */}
            {activeRows.length > 0 && kpiCards([
                { label: "Total Bills", value: String(totalBills), accent: false },
                { label: "Bill Amount", value: `₹ ${fmt(totalBillAmt)}`, accent: false },
                { label: "Paid Amount", value: `₹ ${fmt(totalPaidAmt)}`, accent: false },
                { label: "Outstanding", value: `₹ ${fmt(totalOS)}`, accent: true },
            ])}

            {/* Main Content Panel */}
            <Box sx={{ p: { xs: 1.5, sm: 2 }, flex: 1 }}>
                <Box sx={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: "6px", overflow: "hidden" }}>

                    {/* Active Filter Status Bar */}
                    {appliedFilters && (
                        <Box sx={{ px: { xs: 1.5, sm: 2 }, py: "9px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, background: TH_BG, borderBottom: `1px solid ${BORDER}` }}>
                            <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", alignItems: "center" }}>
                                <Typography sx={{ fontSize: 10, color: T3, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".5px", mr: 0.5 }}>Active Filters:</Typography>
                                {[getReportTypeLabel(), filterDateLabel, `${appliedFilters.clientCount} client${appliedFilters.clientCount > 1 ? "s" : ""}`].map(tag => (
                                    <Box key={tag} sx={{ px: 1, py: "2px", background: NAVY, borderRadius: "3px" }}>
                                        <Typography sx={{ fontSize: 11, fontWeight: 500, color: WHITE }}>{tag}</Typography>
                                    </Box>
                                ))}
                            </Box>
                            <Button onClick={handleClear} size="small" startIcon={<ClearIcon sx={{ fontSize: 11 }} />} sx={btnGhost}>
                                Clear
                            </Button>
                        </Box>
                    )}

                    {/* Client Tabs */}
                    {selectedClients.length > 0 && (
                        <Box sx={{ borderBottom: `1px solid ${BORDER}` }}>
                            <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} variant="scrollable" scrollButtons="auto"
                                sx={{
                                    px: 1, minHeight: 40,
                                    "& .MuiTabs-indicator": { background: STEEL, height: 2, borderRadius: 0 },
                                    "& .MuiTab-root": { textTransform: "none", fontWeight: 500, fontSize: 13, color: T3, minHeight: 40, px: 2, py: 0, "&.Mui-selected": { color: STEEL, fontWeight: 600 } }
                                }}>
                                {selectedClients.map((client, idx) => {
                                    const count = ledgerDataMap[client.id]?.details?.length || 0;
                                    return (
                                        <Tab key={client.id} id={`tab-${idx}`}
                                            label={
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                                                    <span>{client.FirmName}</span>
                                                    <Box sx={{ minWidth: 18, height: 16, px: "4px", background: count > 0 ? NAVY : T3, borderRadius: "2px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        <Typography sx={{ fontSize: 10, fontWeight: 700, color: WHITE, lineHeight: 1 }}>{count}</Typography>
                                                    </Box>
                                                </Box>
                                            }
                                        />
                                    );
                                })}
                            </Tabs>
                        </Box>
                    )}

                    {/* Grid Content */}
                    {selectedClients.map((client, idx) => {
                        if (idx !== activeTab) return null;
                        const clientData = ledgerDataMap[client.id];
                        const displayRows = clientData?.details || [];
                        const billAmt = clientData?.summary?.totalDebit || 0;
                        const paidAmt = clientData?.summary?.totalCredit || 0;
                        const osAmt = displayRows.reduce((s, r) => s + Number(r.OSAmt || 0), 0);
                        return (
                            <Box key={client.id}>
                                {loading ? (
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 6, gap: 1.5 }}>
                                        <CircularProgress size={20} sx={{ color: STEEL }} />
                                        <Typography sx={{ color: T2, fontSize: 13 }}>Loading bills…</Typography>
                                    </Box>
                                ) : displayRows.length > 0 ? (
                                    <>
                                        <DataGrid
                                            rows={displayRows} columns={columns}
                                            autoHeight rowHeight={38}
                                            getRowId={(row) => row.id}
                                            disableRowSelectionOnClick
                                            pageSizeOptions={[25, 50, 100]}
                                            initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
                                            sx={dgSx}
                                        />
                                        {/* Totals Footer */}
                                        <Box sx={{ background: TH_BG, borderTop: `1px solid ${BORDER}`, px: { xs: 1.5, sm: 2.5 }, py: 1.25, display: "flex", alignItems: "center", gap: { xs: 2, sm: 4 }, flexWrap: "wrap" }}>
                                            <Typography sx={{ fontSize: 11, fontWeight: 700, color: T2, textTransform: "uppercase", letterSpacing: ".4px" }}>
                                                {displayRows.length} Bill{displayRows.length !== 1 ? "s" : ""}
                                            </Typography>
                                            <Box sx={{ display: "flex", gap: { xs: 2, sm: 3 }, ml: "auto", flexWrap: "wrap" }}>
                                                {[
                                                    { label: "Bill Amt", val: fmt(billAmt), color: T1 },
                                                    { label: "Paid Amt", val: fmt(paidAmt), color: POS },
                                                    { label: "Outstanding", val: fmt(osAmt), color: NEG },
                                                ].map(({ label, val, color }) => (
                                                    <Box key={label} sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
                                                        <Typography sx={{ fontSize: 11, color: T3 }}>{label}:</Typography>
                                                        <Typography sx={{ fontSize: 13, fontWeight: 700, color, fontVariantNumeric: "tabular-nums" }}>₹ {val}</Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>
                                    </>
                                ) : (
                                    <Box sx={{ py: 5, textAlign: "center" }}>
                                        <ReceiptLongOutlinedIcon sx={{ fontSize: 30, color: BORDER, mb: 1 }} />
                                        <Typography sx={{ fontSize: 13, color: T3 }}>No bills found for {client.FirmName}</Typography>
                                    </Box>
                                )}
                            </Box>
                        );
                    })}
                </Box>
            </Box>

            <OSandODSaleFilterDialog {...dialogProps} />
            {snackbarEl}
        </Box>
    );
}
